<div class="asset-allocated-container">
  <div class="asset-header">
    <div class="header-container">
      <app-title-field
        [title]="'Asset Allocated'"
        [icon]="'devices'"
        [iconUrl]="''"
        [showLink]="true"
        (click)="navigateToAssetDetails()"
      ></app-title-field>
    </div>

    <div class="dropdown-container">
      <app-dropdown
        [options]="monthOptions"
        [label]="'Select Month'"
        [displayKey]="'label'"
        [valueKey]="'value'"
        [(ngModel)]="selectedMonthValue"
        (dropdownChange)="onMonthSelect($event)"
      ></app-dropdown>
    </div>
  </div>

  <div *ngIf="isLoading" class="card-loading-overlay">
    <div class="card-spinner">
      <div class="spinner"></div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && allocationData.length > 0; else noDataTemplate" class="chart-and-summary">
    <div class="mini-chart-container asset-allocated-chart">
      <app-chart
        [type]="'bar'"
        [data]="chartData"
        [xKey]="xKeyForChart"
        [yKeys]="yKeysForChart"
        [width]="chartWidth"
        [height]="chartHeight"
        [ariaLabel]="'Asset allocation bar chart'"
      >
      </app-chart>
    </div>
    <div class="asset-summary" aria-label="Asset totals summary">
      <div class="summary-header">
        <span class="col-asset">Assets</span>
        <span class="col-number">Number</span>
      </div>
      <div class="summary-rows">
        <div
          class="summary-row"
          *ngFor="let row of assetTotals"
          [ngClass]="row.asset.toLowerCase()"
        >
          <span class="legend-marker" aria-hidden="true"></span>
          <span class="col-asset">{{ row.asset }}</span>
          <span class="col-number">{{ row.total }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container>
          <h3 class="empty-state-title">{{ errorMsg }}</h3>
        </ng-container>
        <img
          [src]="imageSrc"
          alt="No records illustration"
          class="empty-state-image"
        />
      </div>
    </section>
  </ng-template>
</div>
